import { useState } from "react"

import { EmptyStateWithImage } from "src/components/EmptyState/EmptyStateWithImage"
import { CreateTaskDialog } from "src/components/TaskManagement/CreateTaskDialog"
import { usePostCreateTaskInitiated } from "src/data/analytics/queries/taskManagementAnalyticsQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { MButton } from "src/ui/Button/MButton"

import NoTasksEmptyStateImage from "./images/no-tasks.svg"

export function NoTasks() {
  const { t, langKeys } = useTranslate()
  const [openDialog, setOpenDialog] = useState(false)

  const postCreateTaskInitiated = usePostCreateTaskInitiated()

  function handleClickAddTask() {
    setOpenDialog(true)
    postCreateTaskInitiated.mutate()
  }

  return (
    <>
      <EmptyStateWithImage
        Image={NoTasksEmptyStateImage}
        title={t(langKeys.task_management_no_tasks_empty_state_title)}
        description={t(langKeys.task_management_no_tasks_empty_state_body)}
        content={
          <MButton onClick={handleClickAddTask}>
            {t(langKeys.task_management_create_a_new_task)}
          </MButton>
        }
      />

      {openDialog && <CreateTaskDialog onClose={() => setOpenDialog(false)} />}
    </>
  )
}
